import LimitPriceWrapper from './LimitPriceWrapper'
import TradeFeeWrapper from './TradeFeeWrapper'
import FastSellPriceWrapper from './FastSellPriceWrapper'
import { StyledExpandedRateArea } from './styled'

const ExpandedRateArea: React.FC = () => {
  return (
    <StyledExpandedRateArea>
      <LimitPriceWrapper />
      <FastSellPriceWrapper />
      <TradeFeeWrapper />
    </StyledExpandedRateArea>
  )
}

export default ExpandedRateArea
